export default {
  API_ENDPOINT: 'https://blooming-brook-76925.herokuapp.com/api',
  TOKEN_KEY: 'spaced-repetition-client-auth-token',
}
